<header>
  <div class="flex">
    <a [href]="'HEADER.LINK' | translate" aria-label="RBC Business Homepage">
      <img class="rbc-logo" [src]="'images/rbc-logo.png' | assetUrl" alt="logo" />
    </a>
    <div class="call">
      <div class="end">
        <div>{{ "GLOBAL.HELP" | translate }}</div>
        <div class="phone">
          <rbc-icon name="support" size="md"></rbc-icon>
          <a href="tel:+18668262473" aria-label="RBC Phone number" class="cta">{{ "GLOBAL.1800" | translate }}</a>
        </div>
      </div>
    </div>
  </div>
</header>
